import { createStore } from 'vuex'
import createMutationsSharer from 'vuex-shared-mutations'
import createCrmStagesModule from './modules/crm-stages'
import createCustomPropertiesModule from './modules/custom-properties'
import createSavedFiltersModule from './modules/saved-filters'
import createTagsModule from './modules/tags'
import SimpleModuleMaker from './simple-module-maker'

export default function () {
  const plugins = []

  try {
    const sharer = createMutationsSharer({
      predicate: (mutation, _state) => {
        const notSharedMutations = [
          'Video/loading',
          'Video/loaded',
        ]

        return !notSharedMutations.includes(mutation.type)
      },
    })

    plugins.push(sharer)
  }
  catch (_err) {

  }

  return createStore({
    plugins,
    modules: {
      CrmDealPipelines: SimpleModuleMaker('api.crm-deal-pipeline.index'),
      CustomProperties: createCustomPropertiesModule(),
      CrmStages: createCrmStagesModule(),
      SavedFilters: createSavedFiltersModule(),
      Tags: createTagsModule(),
      TeamMembers: SimpleModuleMaker('api.team.member.index', { no_pagination: '1' }),
      TeamGroups: SimpleModuleMaker('api.team.group.index'),
      TeamRoles: SimpleModuleMaker('api.team.role.index'),
      YoutubeCredentials: SimpleModuleMaker('api.youtube_credential.index'),
    },
  })
}
